import React from 'react';

function BrandLogo({ compact = false, bare = false, onClick, title = 'Cloudnotes home' }) {
  const Element = onClick ? 'button' : 'div';

  return (
    <Element
      className={`cloudnotes-brand${compact ? ' cloudnotes-brand--compact' : ''}${bare ? ' cloudnotes-brand--bare' : ''}`}
      onClick={onClick}
      title={onClick ? title : undefined}
      type={onClick ? 'button' : undefined}
    >
      <img
        src="/cloudnotes-logo.webp"
        alt="Cloudnotes by Inframodule"
        width="900"
        height="300"
        className="cloudnotes-brand__image"
      />
    </Element>
  );
}

export default BrandLogo;
